/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, checkValidation } from '../../../api/api'; // eslint-disable-next-line
import config from '../../../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify';
// eslint-disable-next-line
import FormGroupInput from '../../../common/FormGroupInput';
import { Row, Col, Button } from 'react-bootstrap';
// eslint-disable-next-line
import CopiriLoader from '../../../common/CopiriLoader';
import image_loader from '../../../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
const FacebookField = props => {
	// eslint-disable-next-line
	const { lodgeData, id, closeModal, updateLodgeModal, pageLanguageContent } = props; // eslint-disable-next-line
	const [checkDataChange, setCheckDataChange] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [inputField, setInputField] = useState({
		facebook: ''
	});

	const [validation, setValidation] = useState({
		error_facebook: ''
	});

	useEffect(() => {
		if (props.id) {
			const { facebook } = lodgeData.social;
			setInputField({ ...inputField, facebook });
			//if (facebook !=='Rite not provided.')
		}
		// eslint-disable-next-line
	}, [props.id]);

	const inputsHandler = e => {
		setCheckDataChange(true);
		setInputField({ ...inputField, [e.target.name]: e.target.value });
	};

	function updateData() {
		let errors = { ...validation };
		var errorCount = 0;
		var checkError = checkValidation(inputField.facebook, 'url');
		if (!inputField.facebook) {
			errors.error_facebook = pageLanguageContent['CLD071'];
			errorCount++;
		} else if (!checkError) {
			errors.error_facebook = pageLanguageContent['CLD077'];
			errorCount++;
		} else {
			errors.error_facebook = '';
		}
		var sendData = {};
		sendData['value'] = inputField['facebook'];
		sendData['type'] = 'Facebook';

		let obj = {};
		obj['social'] = '';
		// eslint-disable-next-line
		let obj2 = {
			social: {
				facebook: inputField['facebook']
			}
		};
		setValidation(errors);
		if (errorCount <= 0) {
			setShowLoader(true);
			copiriPortalRequest('/organizations/' + id + '/additional-info', config.app_version, 'patch', sendData)
				.then(response => {
					setShowLoader(false);
					if (response.data.status && response.data.status === 'SUCCESS') {
						toast.success(pageLanguageContent['CLD119']);
						closeModal();
						updateLodgeModal('social', inputField['facebook'], 'facebook', 'facebook_link');
					}
				})
				.catch(error => {
					toast.error(error.response.data.result);
					setShowLoader(false);
				});
		}
	}
	return (
		<Row className='mt-2'>
			<Col lg={12}>
				<FormGroupInput
					id='facebookField'
					label={pageLanguageContent['CLD037'] ? pageLanguageContent['CLD037'] : ''}
					placeholder={pageLanguageContent['CLD178'] ? pageLanguageContent['CLD178'] : ''}
					type='text'
					name='facebook'
					onChange={inputsHandler}
					value={inputField.facebook}
				/>
				{validation.error_facebook && <p className='formValidationError'>{validation.error_facebook}</p>}
			</Col>
			<Col lg={12}>
				{inputField.facebook && (
					<p style={{ position: 'absolute' }}>
						<a
							href={inputField.facebook}
							target='_blank'
							rel='noopener noreferrer'
							data-toggle='tooltip'
							title={inputField.facebook}
						>
							{pageLanguageContent['CLD190'] ? pageLanguageContent['CLD190'] : ''}
						</a>
					</p>
				)}
				<Button
					variant='primary'
					id={'confirmValidatebutton'}
					style={{ float: 'right', marginBottom: '15px' }}
					onClick={updateData}
				>
					{showLoader ? (
						<img src={image_loader} alt='loader' height='20' width='20' />
					) : pageLanguageContent['CLD124'] ? (
						pageLanguageContent['CLD124']
					) : (
						''
					)}
				</Button>
			</Col>
		</Row>
	);
};
export default FacebookField;
